import { useEffect, useRef, useState } from "react";
import { attachPlayerTextTrackCuePositioning, positionPlayerTextTrackCues } from "@/pages/playerTextTracks";
import { PauseIcon } from "@/components/PlayerIcons";

export function VisualCCHarnessPage() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [readyState, setReadyState] = useState("loading");

  useEffect(() => {
    const video = videoRef.current;
    if (!video) {
      return;
    }

    const showTextTracks = () => {
      for (let index = 0; index < video.textTracks.length; index += 1) {
        const track = video.textTracks[index];
        if (track) {
          track.mode = "showing";
        }
      }
      positionPlayerTextTrackCues(video);
    };
    const detachCuePositioning = attachPlayerTextTrackCuePositioning(video);

    const start = async () => {
      showTextTracks();
      try {
        video.currentTime = 4;
        await video.play();
        setReadyState("playing");
      } catch {
        setReadyState("manual");
      }
    };

    video.addEventListener("loadedmetadata", start);
    video.addEventListener("loadeddata", showTextTracks);
    video.addEventListener("cuechange", showTextTracks);
    return () => {
      video.removeEventListener("loadedmetadata", start);
      video.removeEventListener("loadeddata", showTextTracks);
      video.removeEventListener("cuechange", showTextTracks);
      detachCuePositioning();
    };
  }, []);

  return (
    <div className="player-page visual-cc-harness-page" data-testid="visual-cc-harness">
      <video
        ref={videoRef}
        className="video-player visual-cc-harness-video"
        data-testid="visual-cc-video"
        muted
        playsInline
        preload="auto"
        src="/__debug/visual-cc-harness/video.webm"
      >
        <track
          default
          kind="subtitles"
          label="Forced"
          src="/__debug/visual-cc-harness/subtitles.vtt"
          srcLang="en"
        />
      </video>

      <div className="player-topbar visual-cc-harness-topbar">
        <div className="player-title-block">
          <span className="player-title-kicker">Visual Validation</span>
          <span className="player-title">Subtitle Harness</span>
          <span className="player-title-meta" data-testid="visual-cc-state">{readyState}</span>
        </div>
      </div>

      <div className="player-controls visual-cc-harness-controls" data-testid="visual-cc-controls">
        <div className="player-progress">
          <span className="player-time">0:04</span>
          <div className="player-seek-wrap">
            <div className="player-seek-rail" aria-hidden="true">
              <div className="player-seek-rail-fill" style={{ width: "35%" }} />
            </div>
            <div
              role="slider"
              aria-label="Visual CC Harness Seek"
              aria-valuemin={0}
              aria-valuemax={12}
              aria-valuenow={4}
              aria-valuetext="0:04"
              className="player-seek"
              tabIndex={-1}
            />
            <div className="player-seek-thumb" style={{ left: "35%" }} />
          </div>
          <span className="player-time">0:12</span>
        </div>
        <div className="player-controls-row">
          <div className="player-controls-left">
            <button className="player-btn" type="button" aria-label="Pause"><PauseIcon /></button>
          </div>
          <div className="player-controls-right">
            <label className="player-subtitle-control" title="Subtitles: Forced">
              <span className="player-quality-label">CC</span>
              <span className="player-pill-value" aria-hidden="true">Forced</span>
              <select className="player-quality-select" aria-label="Subtitle track" value="forced" onChange={() => {}}>
                <option value="forced">Forced</option>
              </select>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
